export default class AccountsSetup {

  constructor() {}

  render() {

    // Poll for setup status
    let setupStatusPoll = () => {
      let accountUrl = $('body').attr('data-account-url');
      let url = '/' + accountUrl + '/setup.js';

      // Execute ajax request
      $.ajax({
        type: "GET",
        dataType: "script",
        timeout: 2000,
        url: url,
        complete() {
          setTimeout(function() { setupStatusPoll() }, 2000);
        }
      });

    };

    // Poll server for status of account setup
    setupStatusPoll();

  }

}
